// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login"; // Correct import
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import Payments from "./pages/Payments";
import Results from "./pages/Results";
import AdminResults from "./pages/AdminResults";
import AdminUsers from "./pages/AdminUsers";
import Register from "./pages/RegisterAdmin";
import EditProfile from "./pages/EditProfile";
import NewStudents from "./pages/NewStudent";
import SchoolPage from "./pages/SchoolPage";
import ProgrammePage from "./pages/ProgrammePage";
import BiodataForm from "./components/BiodataForm";
import ApplicantLogin from "./pages/ApplicantLogin";
import ApplicantPage from "./pages/ApplicantPage";
import ApplicantPayments from "./pages/ApplicantPayments";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import ProtectedRoute from "./components/PrivateRoute";
import AuthGuard from "./components/AuthGuard";
import ApplicantPaymentsEdit from "./pages/ApplicantPaymentsEdit";
import StudentBioDataForm from "./components/biodata";
import PromoteStudents from "./pages/PromoteStudents";
import StaffResultInput from "./pages/StaffResultInput";
import StaffCourses from "./staff/StaffCourses";
import StaffAttendance from "./staff/StaffAttendance";
import StaffAssessments from "./staff/StaffAssessment";
import StudentLookup from "./staff/StudentLookup";
import RegisteredCoursesView from "./student/RegisteredCoursesView";
import PaymentHistory from "./student/PaymentHistory";
import StudentFeesPayment from "./student/StudentFeesPayment";
import StudentProfileView from "./student/StudentProfileView";
import NewsPage from "./pages/NewsPage";
import SchoolUTMECalendar from "./pages/UTMECalender";
import CoursesPage from "./staff/StaffCourses";
import Reports from "./pages/Reports";
import StaffReport from "./staff/StaffReports";
import HODRegister from "./pages/HODRegister";
import ChangePassword from "./student/ChangePassword";
import ViewStudentsPage from "./pages/ViewStudentsPage";
import StaffChangePassword from "./staff/StaffChangePassword";
import AdminViewResultsPage from "./pages/AdminViewResultsPage";
import AdminChangePassword from "./pages/AdminChangePassword";

// import Navbar from "./components/Navbar";

function App() {
  return (
    <div>
      {/* <Navbar /> */}
      <Router>
        <AuthGuard>
          <Routes>
            <Route path="/portal" element={<Login />} />
            <Route path="/" element={<NewStudents />} />
            <Route path="/programme" element={<ProgrammePage />} />
            <Route
              path="/school/:schoolKey/:departmentKey?"
              element={<SchoolPage />}
            />
            <Route path="/applicant-login" element={<ApplicantLogin />} />
            <Route path="/news" element={<NewsPage />} />
            <Route
              path="/post-utme-calendar"
              element={<SchoolUTMECalendar />}
            />
            {/* protected */}
            {/* protected single route */}
            <Route
              path="/biodata"
              element={
                <ProtectedRoute>
                  <BiodataForm />
                </ProtectedRoute>
              }
            />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/edit-profile/:matricNo" element={<EditProfile />} />
            <Route
              path="/registered-courses"
              element={<RegisteredCoursesView />}
            />
            <Route path="/payment-history" element={<PaymentHistory />} />
            <Route path="/pay-fees" element={<StudentFeesPayment />} />
            <Route
              path="/student-change-password"
              element={<ChangePassword />}
            />
            {/* // e.g. in App.js or wherever you define routes */}
            <Route path="/payments" element={<Payments />} />

            <Route path="/results" element={<Results />} />
            <Route path="/student-profile" element={<StudentProfileView />} />
            <Route path="/admin/results" element={<AdminResults />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/change-password" element={<AdminChangePassword />} />
            <Route
              path="/admin/view-student-data"
              element={<ViewStudentsPage />}
            />
            <Route
              path="/admin/view-student-results-all"
              element={<AdminViewResultsPage />}
            />

            <Route path="/applicants" element={<ApplicantPage />} />
            <Route path="/promote-students" element={<PromoteStudents />} />
            <Route
              path="/applicants-payments"
              element={<ApplicantPayments />}
            />
            <Route path="/reports" element={<Reports />} />
            <Route
              path="/applicants-payments-edit"
              element={<ApplicantPaymentsEdit />}
            />
            <Route path="/admin/register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/staff-results" element={<StaffResultInput />} />
            <Route path="/staff/dashboard" element={<Dashboard />} />
            <Route path="/staff/courses" element={<StaffCourses />} />
            <Route path="/staff/attendance" element={<StaffAttendance />} />
            <Route path="/staff/assignments" element={<StaffAssessments />} />
            <Route path="/staff/students" element={<StudentLookup />} />
            <Route
              path="/staff/staff-change-password"
              element={<StaffChangePassword />}
            />
            <Route path="/staff/reports" element={<StaffReport />} />
            <Route path="/staff/payments" element={<CoursesPage />} />
            <Route path="/hod/admin-register" element={<HODRegister />} />
            {/* <Route path="/staff/course-page" element={<CoursesPage />} /> */}
          </Routes>
        </AuthGuard>
      </Router>
    </div>
  );
}

export default App;
